import { useLazyQuery, useQuery, useMutation } from '@apollo/client';
import {
  GET_PRIVACY_TERMS,
  GET_TERMS_AND_CONDITIONS,
} from '../../containers/Auth/query';
import HtmlRenderer from '../Common/HtmlRenderer/HtmlRenderer';
import { useEffect } from 'react';
import { getDefaultLangFromLocalStorage } from '../../common/functions';
const TermsAndService = () => {
  const [getPrivacyTerms, { data, loading }] = useMutation(GET_PRIVACY_TERMS);

  useEffect(() => {
    getPrivacyTerms({
      variables: { language: getDefaultLangFromLocalStorage() },
    });
  }, []);
  if (loading) return <div>Loading...</div>;
  return (
    <div
      style={{
        lineHeight: '2rem',
      }}
    >
      <HtmlRenderer content={data && data.get_tnc.value} />
    </div>
  );
};
export default TermsAndService;
